import type {
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  WithFieldValue
} from 'firebase/firestore'
import type {
  Pantry,
  PantryItem,
  Recipe,
  RecipeBook,
  RecipeBookRecipePage,
  UserProfile
} from './firestore'

const createSnapshotConverter = <T extends { id?: string }>() => {
  const converter: FirestoreDataConverter<T> = {
    toFirestore(modelObject: WithFieldValue<T>): DocumentData {
      const { id, ...data } = modelObject as any
      return data
    },
    fromFirestore(snapshot: QueryDocumentSnapshot): T {
      return {
        id: snapshot.id,
        ...(snapshot.data() as DocumentData)
      } as T
    }
  }

  return converter
}

export const recipeConverter = createSnapshotConverter<Recipe>()
export const recipeBookConverter = createSnapshotConverter<RecipeBook>()
export const recipePageConverter = createSnapshotConverter<RecipeBookRecipePage>()
export const pantryConverter = createSnapshotConverter<Pantry>()
export const pantryItemConverter = createSnapshotConverter<PantryItem>()

// UserProfile converter - separate because it uses uid instead of id
export const userProfileConverter: FirestoreDataConverter<UserProfile> = {
  toFirestore(modelObject: WithFieldValue<UserProfile>): DocumentData {
    const { uid, ...data } = modelObject as any
    return data
  },
  fromFirestore(snapshot: QueryDocumentSnapshot): UserProfile {
    return {
      uid: snapshot.id,
      ...(snapshot.data() as DocumentData)
    } as UserProfile
  }
}
